import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=48dd1d50&lang=scss&scoped=true"

import exportComponent from "/ssd-jenkins/workspace/fe-test-beluga/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48dd1d50"]])

export default __exports__